import { render, staticRenderFns } from "./TaskAssignedActivity.vue?vue&type=template&id=61df857c"
import script from "./TaskAssignedActivity.vue?vue&type=script&lang=js"
export * from "./TaskAssignedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports